import { FieldMergeFunction, Reference, StoreObject } from '@apollo/client';

type CacheItem = Reference | StoreObject;

export const mergeWithDedupe: FieldMergeFunction<CacheItem[]> = (
  existing = [],
  incoming,
  { args, readField }
) => {
  if (!args?.offset) {
    return incoming;
  }

  const existingIds = new Set<string | number | undefined>(
    existing.map(item => readField('id', item))
  );

  const uniqueIncoming = incoming.filter(item => {
    const incomingId = readField<string | number>('id', item);
    return !existingIds.has(incomingId);
  });

  return [...existing, ...uniqueIncoming];
};
